import { axiosDS } from '@pp/axios'
import { FilterStatusesModel } from 'Pages/advertisement'
import { urls } from 'Constants/Urls'

export const statusesApi = {
	getFilterStatuses: async (tab: string) => {
		const res = await axiosDS().get<FilterStatusesModel[]>(
			urls.advertisement.statuses.replace(':tab', tab)
		)
		return res.data
	},
}
